import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=59efc51d&"
import script from "./Price.vue?vue&type=script&lang=js&"
export * from "./Price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports